import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["role"];

  apply() {
    const defaults = JSON.parse(
      this.element.querySelector("[data-default-permissions]").dataset
        .defaultPermissions,
    );
    const selected = defaults[this.roleTarget.value] || [];
    this.element.querySelectorAll("[data-permission]").forEach((checkbox) => {
      checkbox.checked = selected.includes(checkbox.dataset.permission);
    });
  }
}
